export const OTP_VERIFY_RESET = "OTP_VERIFY_RESET";
export const OTP_VERIFY_START = "OTP_SUBMIT_START";
export const OTP_VERIFY_SUCCESS = "OTP_SUBMIT_SUCCESS";
export const OTP_VERIFY_FAIL = "OTP_SUBMIT_FAIL";
